// extracted by mini-css-extract-plugin
module.exports = {"root":"PTNQe2","link":"VEs1BL"};